import { Box, Stack, Typography } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import OtpInput from "../customComponents/OtpInput";
import useCountdown from "../customHooks/useCountdown";
import { loginCodeLength } from "../../constants";
import { StepHeader, StepMessage, TextButton, submitButtonSx } from "./common";

export default function VerifyCodeStep({
  code,
  onCodeChange,
  maskedPhoneNumber,
  resendAt,
  resendsRemaining,
  canChangeNumber,
  onVerify,
  onResend,
  onChangeNumber,
  onBack,
  isSubmitting,
  isResending,
  error,
  notice,
}) {
  const resendIn = useCountdown(resendAt);
  const isComplete = code.length === loginCodeLength;

  function handleSubmit(event) {
    event.preventDefault();
    if (isComplete) onVerify(code);
  }

  function renderResend() {
    if (resendsRemaining <= 0) {
      return (
        <Typography variant="body2" color="text.secondary">
          Still no code? Go back and sign in again.
        </Typography>
      );
    }

    if (resendIn > 0) {
      return (
        <Typography variant="body2" color="text.secondary">
          Didn’t get it? Resend code in {resendIn}s
        </Typography>
      );
    }

    return (
      <TextButton onClick={onResend} disabled={isResending}>
        {isResending ? "Sending…" : "Didn’t get it? Resend code"}
      </TextButton>
    );
  }

  return (
    <Box component="form" noValidate onSubmit={handleSubmit}>
      <StepHeader title="Verify it’s you">
        Enter the {loginCodeLength}-digit code we sent to{" "}
        <Box component="span" sx={{ color: "text.primary", fontWeight: 600, whiteSpace: "nowrap" }}>
          {maskedPhoneNumber}
        </Box>
        .
      </StepHeader>

      <OtpInput
        autoFocus
        length={loginCodeLength}
        value={code}
        onChange={onCodeChange}
        onComplete={onVerify}
        error={Boolean(error)}
        readOnly={isSubmitting}
      />

      <StepMessage error={error} notice={notice} />

      <LoadingButton
        fullWidth
        type="submit"
        variant="contained"
        loading={isSubmitting}
        disabled={!isComplete}
        sx={submitButtonSx}
      >
        Verify
      </LoadingButton>

      <Stack spacing={1.5} alignItems="center" sx={{ mt: 3 }}>
        {renderResend()}
        {canChangeNumber && <TextButton onClick={onChangeNumber}>Change mobile number</TextButton>}
        <TextButton onClick={onBack}>Back to sign in</TextButton>
      </Stack>
    </Box>
  );
}
